<template>
<div>
    <!-- reservations FILTERS -->
    <v-row class="mt-2 mx-n1" no-gutters>
        <!-- status filter-->
        <v-col cols="6" md="4" lg="2" class="px-1">
            <v-card class="mb-3 elevation-1">
                <div class="pa-1">
                    <div class="detail font-weight-bold pa-0 ma-0">{{ $t('reservations.filter.status') }}</div>
                    <v-select class="im-select truncate pa-0 ma-0" flat solo v-model="status_filter" :items="status_items" :placeholder="$t('reservations.filter.any')" clearable :menu-props="{transition:'scale-transition', 'offset-y': ''}" @input="filterItems()"
                        hide-details />
                </div>
            </v-card>
        </v-col>
        <!--./ status filter-->
        <!-- Room Type filter-->
        <v-col cols="6" md="4" lg="2" class="px-1">
            <v-card class="mb-3 elevation-1">
                <div class="pa-1">
                    <div class="detail font-weight-bold pa-0 ma-0">{{ $t('reservations.filter.room_type') }}</div>
                    <v-select class="im-select pa-0 ma-0 truncate" flat solo v-model="room_type_id" :items="room_types" item-text="name" item-value="id" :placeholder="$t('reservations.filter.any')" clearable :menu-props="{transition:'scale-transition', 'offset-y': ''}"
                        @input="filterItems()" hide-details />
                </div>
            </v-card>
        </v-col>
        <!--./ Room Type filter-->
        <!-- Rate Plan filter-->
        <v-col cols="6" md="4" lg="2" class="px-1">
            <v-card class="mb-3 elevation-1">
                <div class="pa-1">
                    <div class="detail font-weight-bold pa-0 ma-0">{{ $t('reservations.filter.rate_plan') }}</div>
                    <v-select class="im-select pa-0 ma-0  truncate" flat solo v-model="rate_plan_id" :items="rate_plans" item-text="name" item-value="id" :placeholder="$t('reservations.filter.any')" clearable :menu-props="{transition:'scale-transition', 'offset-y': ''}"
                        @input="filterItems()" hide-details />
                </div>
            </v-card>
        </v-col>
        <!--./ Rate Plan filter-->
        <!-- Create date filter-->
        <v-col cols="6" md="4" lg="2" class="px-1">
            <v-card class="mb-3 elevation-1">
                <div class="pa-1">
                    <div class="detail font-weight-bold pa-0 ma-0">{{ $t('reservations.filter.booking_date') }}</div>
                    <div class="d-flex">
                        <v-menu transition="scale-transition" offset-y>
                            <template v-slot:activator="{ on }">
                                <v-text-field v-on="on" class="im-select ma-0" flat solo readonly :placeholder="$t('reservations.filter.from')" v-model="comp_timestamp_after" @input="filterItems()" hide-details />
                            </template>
                            <v-date-picker v-model="timestamp_after" no-title @input="filterItems()" width="250" :locale="$vuetify.lang.current">
                                <v-spacer />
                                <v-btn text color="red" @click="timestamp_after = null;filterItems()">{{ $t('button.clear_date') }}</v-btn>
                            </v-date-picker>
                        </v-menu>
                        <v-icon small class="mx-0">arrow_forward</v-icon>
                        <v-menu transition="scale-transition" offset-y>
                            <template v-slot:activator="{ on }">
                                <v-text-field v-on="on" class="im-select ma-0" flat solo readonly :placeholder="$t('reservations.filter.until')" v-model="comp_timestamp_before" @input="filterItems()" hide-details />
                            </template>
                            <v-date-picker v-model="timestamp_before" no-title @input="filterItems()" width="250" :locale="$vuetify.lang.current">
                                <v-spacer />
                                <v-btn text color="red" @click="timestamp_before = null;filterItems()">{{ $t('button.clear_date') }}</v-btn>
                            </v-date-picker>
                        </v-menu>
                    </div>
                </div>
            </v-card>
        </v-col>
        <!--./ Create date filter-->
        <!-- check in filter-->
        <v-col cols="6" md="4" lg="2" class="px-1">
            <v-card class="mb-3 elevation-1">
                <div class="pa-1">
                    <div class="detail font-weight-bold">Check in</div>
                    <div class="d-flex">
                        <v-menu transition="scale-transition" offset-y>
                            <template v-slot:activator="{ on }">
                                <v-text-field v-on="on" class="im-select ma-0 pa-0" flat solo readonly slot="activator" :placeholder="$t('reservations.filter.after')" v-model="comp_check_in_after" @input="filterItems()" hide-details></v-text-field>
                            </template>
                            <v-date-picker v-model="check_in_after" no-title @input="filterItems()" width="250" :locale="$vuetify.lang.current">
                                <v-spacer />
                                <v-btn text color="red" @click="check_in_after = null;filterItems()">{{ $t('button.clear_date') }}</v-btn>
                            </v-date-picker>
                        </v-menu>
                        <v-icon small class="mx-0">arrow_forward</v-icon>
                        <v-menu transition="scale-transition" offset-y>
                            <template v-slot:activator="{ on }">
                                <v-text-field v-on="on" class="im-select ma-0" flat solo readonly slot="activator" :placeholder="$t('reservations.filter.before')" v-model="comp_check_in_before" @input="filterItems()" hide-details></v-text-field>
                            </template>
                            <v-date-picker v-model="check_in_before" no-title @input="filterItems()" width="250" :locale="$vuetify.lang.current">
                                <v-spacer />
                                <v-btn text color="red" @click="check_in_before = null;filterItems()">{{ $t('button.clear_date') }}</v-btn>
                            </v-date-picker>
                        </v-menu>
                    </div>
                </div>
            </v-card>
        </v-col>
        <!--./ check in filter-->
        <!-- check out filter-->
        <v-col cols="6" md="4" lg="2" class="px-1">
            <v-card class="mb-3 elevation-1">
                <div class="pa-1">
                    <div class="detail font-weight-bold">Check out</div>
                    <div class="d-flex">
                        <v-menu transition="scale-transition" offset-y>
                            <template v-slot:activator="{ on }">
                                <v-text-field v-on="on" class="im-select ma-0" flat solo readonly :clearable="$vuetify.breakpoint.smAndUp" :placeholder="$t('reservations.filter.after')" v-model="comp_check_out_after" @input="filterItems()"
                                    hide-details />
                            </template>
                            <v-date-picker v-model="check_out_after" no-title @input="filterItems()" width="250" :locale="$vuetify.lang.current">
                                <v-spacer />
                                <v-btn text color="red" @click="check_out_after = null;filterItems()">{{ $t('button.clear_date') }}</v-btn>
                            </v-date-picker>
                        </v-menu>
                        <v-icon small class="mx-1">arrow_forward</v-icon>
                        <v-menu transition="scale-transition" offset-y>
                            <template v-slot:activator="{ on }">
                                <v-text-field v-on="on" class="im-select ma-0" flat solo readonly :clearable="$vuetify.breakpoint.smAndUp" :placeholder="$t('reservations.filter.before')" v-model="comp_check_out_before" @input="filterItems()"
                                    hide-details />
                            </template>
                            <v-date-picker v-model="check_out_before" no-title @input="filterItems()" width="250" :locale="$vuetify.lang.current">
                                <v-spacer />
                                <v-btn text color="red" @click="check_out_before = null;filterItems()">{{ $t('button.clear_date') }}</v-btn>
                            </v-date-picker>
                        </v-menu>
                    </div>
                </div>
            </v-card>
        </v-col>
        <!--./ check out filter-->
    </v-row>
    <!-- ./ reservations FILTERS -->

    <!-- SEARCH -->
    <div class="im-search">
        <v-row no-gutters>
            <v-text-field class="ma-0 white pt-0" flat v-model="search" clearable :placeholder="$t('reservations.search_placeholder')" append-icon="search" hide-details></v-text-field>
        </v-row>
        <div class="mx-1 py-2 fields d-flex align-center">
            <div class="detail mr-1 hidden-sm-and-down text-xs-center">Find in:</div>
            <template v-for="(field, index) in search_fields">
                <v-btn class="detail mx-1" :key="field.value" x-small rounded depressed :color="field.selected ? 'primary' : 'grey lighten-2'" @click="selectField(field)">
                    <span :class="['text-capitalize',field.selected ? 'white--text' : '']">{{$t('reservations.search_field.'+ field.text)}}</span>
                </v-btn>
            </template>
        </div>
    </div>
    <!-- ./ SEARCH -->

</div>
</template>

<script>
import qs from "qs";
import {
    mapActions
} from 'vuex';
import logger from '../../../logger.js';

export default {
    name: `widget`,
    components: {},
    props: {
        hotel_id: [String, Number],
    },

    data: () => {
        return {
            menu: false,
            hotel: null,
            // hotel_id: null,
            room_type_id: null,
            rate_plan_id: null,
            rate_plans: [],
            room_types: [],
            hotels: [],
            search_hotel: null,
            loading_hotels: false,
            search_fields: [
                {
                    text: 'booking_id',
                    value: 'id',
                    selected: false
                }, {
                    text: 'client_name',
                    value: 'client_name',
                    selected: false
                }, {
                    text: 'client_email',
                    value: 'client_email',
                    selected: false
                },
            ],

            // filters
            filter: {
                hotel_id: null,
                status: null,
                timestamp: {
                    before: null,
                    after: null,
                },
                check_in: {
                    before: null,
                    after: null,
                },
                check_out: {
                    before: null,
                    after: null,
                },

            },
            status_filter: null,
            timestamp_after: null,
            timestamp_before: null,
            check_in_after: null,
            check_in_before: null,
            check_out_after: null,
            check_out_before: null,

            // search
            search: null,
            search_timeout: 300,
            // table items
            items: [],
            loading: false,
            total: 0,
            pagination: {},
            rppi: [10, 25, 50, 100]
        }
    },

    computed: {
        autoMaxWidth() {
            return this.$refs.hotel_filter.$el.clientWidth - 50
        },
        comp_timestamp_after: {
            get: function () {
                return this.formatDate(this.timestamp_after);
            },
            set: function (val) {
                return this.timestamp_after = val;
            }
        },
        comp_timestamp_before: {
            get: function () {
                return this.formatDate(this.timestamp_before);
            },
            set: function (val) {
                return this.timestamp_before = val;
            }
        },
        comp_check_in_after: {
            get() {
                return this.formatDate(this.check_in_after)
            },
            set(val) {
                this.check_in_after = val;
            }
        },
        comp_check_in_before: {
            get() {
                return this.formatDate(this.check_in_before)
            },
            set(val) {
                this.check_in_before = val;
            }
        },
        comp_check_out_after: {
            get() {
                return this.formatDate(this.check_out_after)
            },
            set(val) {
                this.check_out_after = val;
            }
        },
        comp_check_out_before: {
            get: function () {
                return this.formatDate(this.check_out_before);
            },
            set: function (val) {
                return this.check_out_before = val;
            }
        },
        // status filter
        status_items() {
            return [
                {
                    text: this.$t('reservations.status.booked'),
                    value: "booked"
                }, {
                    text: this.$t('reservations.status.cancelled'),
                    value: "cancelled"
                }, {
                    text: this.$t('reservations.status.no_show'),
                    value: "no-show"
                }
            ]
        }

    },

    watch: {

        search: {
            handler() {
                clearTimeout(this.search_timeout);
                this.search_timeout = setTimeout(this.$emit("search", this.search), 500);
            }
        },

        hotel_id: {
            handler() {
                this.getRatePlans();
                this.getRoomTypes();
            }
        }
    },

    created() {
        this.getRatePlans();
        this.getRoomTypes();
    },

    methods: {

        ...mapActions('alert', ['success', 'error']),

        formatDate(value) {
            if(!value) return value;
            return this.$moment(String(value))
                .locale(this.$vuetify.lang.current)
                .format('D MMM YY');
        },

        getRoomTypes() {
            if(!this.hotel_id) {
                return;
            }

            // prepare stamp & save current_stamp
            let stamp = Date.now();
            this.current_stamp = stamp;

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/console/v1/room-types";

            // setup query params
            let params = {
                params: {
                    hotel_id: this.hotel_id,
                    stamp: stamp,
                }
            };

            return this.$axios.get(endpoint, params)
                .then(response => {
                    this.room_types = response.data.data;
                    return new Promise(function (resolve, reject) {
                        resolve(response.data.data);
                    });
                })
                .catch(error => {
                    // logger.error(error.message, error.stack)
                    //     .then(() => null);
                    this.error('Ooops, something gone wrong');
                    console.log(error);
                })
                .finally(() => {});
        },

        getRatePlans() {
            if(!this.hotel_id) {
                return;
            }

            // prepare stamp & save current_stamp
            let stamp = Date.now();
            this.current_stamp = stamp;

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/console/v1/rate-plans";

            // setup query params
            let params = {
                params: {
                    hotel_id: this.hotel_id,
                    stamp: stamp,
                }
            };

            return this.$axios.get(endpoint, params)
                .then(response => {
                    this.rate_plans = response.data.data;
                    return new Promise(function (resolve, reject) {
                        resolve(response.data);
                    });
                })
                .catch(error => {
                    // logger.error(error.message, error.stack)
                    //     .then(() => null);
                    this.error('Ooops, something went wrong!');
                    console.log(error);
                })
                .finally(() => {});
        },

        selectField(field, index) {
            field.selected = !field.selected;
            let fields = [];
            this.search_fields.forEach(field => {
                if(field.selected) {
                    fields.push(field.value);
                }
            });
            this.$emit('fields', fields)
        },

        filterItems() {
            this.filter = {
                hotel_id: this.hotel_id ? this.hotel_id : null,
                room_type_id: this.room_type_id ? this.room_type_id : null,
                rate_plan_id: this.rate_plan_id ? this.rate_plan_id : null,
                status: this.status_filter ? this.status_filter : null,
                timestamp: {
                    before: this.timestamp_before ? this.timestamp_before : null,
                    after: this.timestamp_after ? this.timestamp_after : null,
                },
                check_in: {
                    before: this.check_in_before ? this.check_in_before : null,
                    after: this.check_in_after ? this.check_in_after : null,
                },
                check_out: {
                    before: this.check_out_before ? this.check_out_before : null,
                    after: this.check_out_after ? this.check_out_after : null,
                },
            };
            this.$emit('filter', this.filter)
        }

    },
}
</script>
